<template>
  <div class="chart-wrapper">
    <div class="chart-container">
      <svg
        class="circle"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="48vh"
        height="48vh"
        viewBox="0 0 165 165"
        enable-background="new 0 0 165 165"
        xml:space="preserve"
      >
        <g>
          <circle
            fill="none"
            stroke="#908F8D"
            stroke-width="21.3"
            stroke-miterlimit="50"
            stroke-dasharray="3,6.7"
            cx="50%"
            cy="50%"
            r="70.15"
          />
        </g>
      </svg>
      <vc-donut
        class="circle-diagram"
        background="#1D1D1B"
        foreground="transparent"
        :size="47.44444"
        unit="vh"
        :thickness="19"
        :total="100"
        :sections="sections"
        ><div class="percents">{{ value }}%</div></vc-donut
      >
    </div>
    <div class="title">{{ $t('cafe_fill_profile.filled_at')}} {{value}}%</div>
  </div>
</template>
<script>
export default {
  props: {
    value: Number
  },
  data() {
    return {
    
    };
  },
  computed: {
    sections() {
      return [{ value: this.value, color: "#AECCC6" }];
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  width: 100%;
}
.chart-container {
  width: 48vh;
  height: 51vh;
  position: relative;
  left: calc(50% - 24vh);
  top: 3.3333333333333335vh;
}
.circle {
  width: 48vh;
  height: 48vh;
  position: absolute;
  top: 0;
  left: -0.2vh;
}

.percents {
  font-size: 7.888888888888889vh;
  line-height: 9.11111111111111vh;
  color: #aeccc6;
}
.title {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #ededed;
  padding-bottom: 0.5555555555555556vh;
  border-bottom: 0.111vh solid #aeccc6;
  margin-top: 5.555555555555555vh;
}
</style>
